import { createSelector } from 'reselect'
import { FEATURED_DEALS_SALE_TYPE } from 'modules/featured-deals/constants'
import getSaleTypeFeaturedDealsSelect from 'modules/featured-deals/redux/selectors/get-sale-type'

const isFeaturedDealsSelect = createSelector(
  getSaleTypeFeaturedDealsSelect,
  saleType => saleType === FEATURED_DEALS_SALE_TYPE.FEATURED_DEALS
)

export default isFeaturedDealsSelect
